﻿// override defaults for selectric to enable on mobile
if ($ && $.fn && $.fn.selectric) {
    $.fn.selectric.defaults.disableOnMobile = false;
    $.fn.selectric.defaults.nativeOnMobile = false;
}

export const UmbracoForm = (function (window, document, undefined) {

    const app = {
        config: {
            activeHelpText: undefined
        },
        events: {

        },
        methods: {

            /*
             * init()
             * Instantiate component when navigation is available, 
             *  set local variables with dom references and call private methods...
             *
            **/

            init: function () {

                const windowObj = $(window);

                if (!windowObj.length) {
                    return;
                }

                const umbracoFormsFields = $('.umbraco-forms-field select');
                if (typeof umbracoFormsFields.selectric === 'function') {
                    umbracoFormsFields.each(function () {
                        const it = $(this);
                        const data = it.data();
                        if (data && data.selectric) {
                            return;
                        }
                        it.selectric({
                            onChange: function (elm) {
                                elm.dispatchEvent(new Event('change')); $(elm).change();
                            }
                        });
                    })
                }

                app.methods.attach();
                app.methods.render();

                if (import.meta.env.DEV) {
                    console.log('[bundle-legacy] UmbracoForm initialized');
                }
            },

            /*
             * render()
             * Render the view...
             *
            **/

            render: function () {

            },

            /*
             * attach()
             * Bind DOM or other events...
             *
            **/

            attach: function () {
                //This needs jquery UI
                //$("input.datepickerfield").datepicker();

                // Add anchors
                $('div[data-scroll-to-me],.contourMessageOnSubmit').each(function () {
                    $('html, body').animate({
                        scrollTop: $(this).offset().top
                    }, 1000);
                });

                // Check for input validation
                $('.umbraco-forms-field input.text').each(function () {
                    app.methods.checkInputOk(this, false);
                });

                $('.umbraco-forms-field input.text').on('change', function () {
                    const $this = this;
                    setTimeout(
                        function () {
                            app.methods.checkInputOk($this, true);
                        }, 500);

                });

                // Set the help text
                // $(".umbraco-forms-field").on({
                //     focusin: function () {
                //         app.methods.showHulpText(this);
                //         $(this).data('hulptext-state', 'focusin');

                //     },
                //     focusout: function () {
                //         app.methods.hideHulpText(this);
                //         $(this).data('hulptext-state', 'focusout');
                //     }
                // });

                $(window).on('resize', function () {
                    if (app.config.activeHelpText !== undefined) {
                        app.methods.showHulpText(app.config.activeHelpText);
                    }
                });
            },

            checkInputOk: function (control, init) {
                if ($(control).data('val-required') !== undefined) {
                    const errorClass = 'input-validation-error';

                    if ($(control).val() !== '' && $(control).hasClass(errorClass) !== true) {
                        $(control).addClass('input-ok');
                    } else {
                        if (init) {
                            $(control).removeClass('input-ok');
                            $(control).addClass(errorClass);
                        }
                    }
                }
            },

            showHulpText: function (control) {
                let $formWidth;
                let $formX;

                if ($(control).get(0) !== undefined) {
                    const $controlX = $(control).offset();
                    app.config.activeHelpText = control;
                    const $windowW = $(window).width();

                    if ($(control).closest('form').get(0) !== undefined) {
                        $formWidth = $(control).closest('form').width();
                        $formX = $(control).closest('form').offset();
                    }

                    if ($(control).find('.help-block').find('.info-icon').get(0) === undefined) {
                        $(control).find('.help-block').html('<div style="display:flex;height:100%;align-items:center;"><div><div class="info-icon"></div>' + $(control).find('.help-block').html() + '</div></div>');
                    }

                    if ($windowW >= 1355) {
                        $(control).find('.help-block')
                            .css('left', ($formWidth - ($controlX.left - $formX.left) + 20) + 'px');
                        $(control).find('.help-block').fadeIn(200);
                    }
                    if ($windowW > 991 && $windowW < 1355) {
                        $(control).find('.help-block').css('display', 'none');
                    }
                    if ($windowW <= 991 && $windowW > 895) {
                        $(control).find('.help-block').css('display', 'none');

                        //$(control).find('.help-block')
                        //    .css('left', ($formWidth - ($controlX.left - $formX.left) - 100) + 'px');
                        //$(control).find('.help-block').fadeIn(200);
                    }
                    if ($windowW <= 895) {
                        $(control).find('.help-block').css('display', 'none');
                    }
                }
            },

            hideHulpText: function (control) {
                $(control).find('.help-block').fadeOut(500);
            }

        }
    };

    return {
        init: app.methods.init
    };

}(window, document, undefined));
